"use strict";

angular.module("core")
.factory("PaymentMethodsBankService", function($resource, $http, appConfig) {
    return {
        getClientAccount: function() {
            return $http.get(appConfig.API_SERVER + "/payment-methods/vopay/" + appConfig.APP + "/client-accounts/");
        },

        updateClientAccount: function(bankAccountId) {
            var data = {default_bank_account: bankAccountId};
            return $http.put(appConfig.API_SERVER + "/payment-methods/vopay/" + appConfig.APP + "/client-accounts/", data);
        },

        updateCompanyDetails: function(data) {
            return $http.post(appConfig.API_SERVER + "/payment-methods/vopay/" + appConfig.APP + "/client-accounts/", data);
        },

        getEmbedURL: function() {
            return $http.get(appConfig.API_SERVER + "/payment-methods/vopay/" + appConfig.APP + "/embed-url/");
        },

        createBankAccount: function(data) {
            return $http.post(appConfig.API_SERVER + "/payment-methods/vopay/" + appConfig.APP + "/bank-accounts/", data);
        },

        getBankAccount: function(bankAccountId) {
            return $http.get(appConfig.API_SERVER + "/payment-methods/vopay/" + appConfig.APP + "/bank-accounts/" + bankAccountId + "/");
        },

        deleteBankAccount: function(bankAccountId) {
            return $http.delete(appConfig.API_SERVER + "/payment-methods/vopay/" + appConfig.APP + "/bank-accounts/" + bankAccountId + "/");
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/payment-methods/payment-methods-bank.service.js
// module id = 441
// module chunks = 0